import { FC, useEffect } from "react";
import { useFeasibilityReadinessQuery } from "./core/_queries";
import { LogError } from "../../../../../utils/GlobalLogging";
import { isAbortedError } from "../../../../../utils/global";

type Props = {
    project_id: string;
};

// SG3 header "Overall Readiness" — the same readiness % the Stage Gate Decision Panel uses (Figma feasPct).
const OverallReadinessCard: FC<Props> = ({ project_id }) => {
    const { readiness, error } = useFeasibilityReadinessQuery(Number(project_id));

    useEffect(() => {
        if (!error || isAbortedError(error)) return;
        LogError("Failed to fetch feasibility readiness percentage", error, "OverallReadinessCard");
    }, [error]);

    return (
        <div className="card card-xxl-stretch border-primary">
            <div className="card-body d-flex flex-column justify-content-between px-3 py-1">
                <div className="d-flex flex-column">
                    <div className='text-primary fw-bold fs-1 mb-0'>{readiness === null ? '—' : `${readiness.readiness_percentage}%`}</div>
                    <div className='text-gray-600 fw-semibold fs-6'>Overall Readiness</div>
                </div>
            </div>
        </div>
    );
};

export { OverallReadinessCard };
